import { Component } from '@angular/core';

@Component({
  selector: 'taly-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
  standalone: false,
})
export class OrderDetailsComponent {}
